import { EventManager } from '@angular/platform-browser';

export class Preview {
	file: any
	title: string
	href: string
	index: number
	key: string
	// dbkey: string
	// folder: string
	ref: string
	// dbref: string
	type: string
	thumbnail: string
	messages: Array<any>
	dimensions: Array<any>
	width: number
	height: number
	size: number
	approved: boolean
	files: Array<any>
	scale: number = 1
	uri: string

	constructor(file, index) {
		this.file = file
		this.title = file.name
		this.href = file.path
		this.index = index
		this.key = file.ref.split('/files/')[1]
		// this.folder = file.folder
		// this.dbkey = file.dbkey
		// this.ref = '/files/' + this.folder
		// this.dbref = file.dbref
		this.type = file.type
		this.thumbnail = file.type.indexOf('image') == 0 ? file.path : file.fallback
		this.dimensions = file.name.match(/\d+x\d+/) ? file.name.match(/\d+x\d+/)[0].split('x') : [0, 0]
		this.width = this.dimensions[0]
		this.height = this.dimensions[1]
		this.size = file.size
		this.approved = file.approved || false
		this.files = file.files || [file.ref]
		this.uri = btoa(file.ref)
		this.messages = Object.values(file.messages || {})
	}

	onslide(slide) {

		let _ = this
		const container = document.querySelector('#gallery-interactions')
		if (container) {
			const approve = container.querySelector('#file-approve') as HTMLInputElement
			approve.checked = this.approved
		}

		if (this.type.indexOf('text') == 0) { // Banners
			slide.querySelector('iFrame').onload = function(e) {
				this.contentWindow.postMessage('SimulateEB', '*')
			}

			if (slide.querySelector('iFrame').contentWindow)
				slide.querySelector('iFrame').contentWindow.location.href = this.href
			// window.addEventListener('message', function(event) {
			// 	console.log('now')
			// 	console.log(event.data)
			// })
		}

		this.resize(slide)

		window.onresize = function() {
			_.resize(slide)
		}
	}

	resize(slide) {
		const container = document.querySelector('#gallery-infos')
		const newwindow = container.querySelector('#file-new-window')
		const refresh = container.querySelector('#file-refresh')

		let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || document.body.offsetWidth,
		h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || document.body.offsetHeight

		// Add a padding on banners with a ratio wider than 1:2
		if (this.width >= this.height * .5) {
			let padding = [0, 65] // [horizontal, vertical] in px
			w -= padding[0] * 2
			h -= padding[1] * 2
		}

		this.scale = 1

		if (this.width > w * this.scale) this.scale *= w / this.width
		if (this.height > h * this.scale) this.scale *= h / this.height

		if (this.type.indexOf('text') == 0 && slide.querySelector('.banner-preview')) { // Banners
			slide.querySelector('.banner-preview').style.transform = `scale(${this.scale})`
		} else if (this.type.indexOf('image') == 0 && this.width !== 0 && this.height !== 0) {
			slide.querySelector('img').style.width = ~~(this.width * this.scale) + 'px'
			slide.querySelector('img').style.height = ~~(this.height * this.scale) + 'px'
		}
	}
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/gallery/preview.ts